import { Component, OnInit } from '@angular/core';
import { WebPage } from '../../shared/web-page';
import { MessageService } from 'primeng/components/common/messageservice';
import { Router, ActivatedRoute } from '@angular/router';
import { ConfirmationService } from 'primeng/primeng';
import { UnidadeService } from '../../shared/services/unidade.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { CustomValidator } from '../../shared/validators/custom.validator';
import { Util } from '../../shared/util';
import { EnderecoService } from '../../shared/services/endereco.service';

@Component({
  selector: 'emprego-na-pistacadastrar-informacoes-complementares',
  templateUrl: './cadastrar-informacoes-complementares.component.html',
  styleUrls: ['./cadastrar-informacoes-complementares.component.css']
})
export class CadastrarInformacoesComplementaresComponent extends WebPage
  implements OnInit {
  idUnidade;
  unidades;
  ufs;
  isCepDefinido = false;
  form: FormGroup;
  get cep() {
    return this.form.get('endereco').get('cep');
  }

  constructor(
    messageService: MessageService,
    private router: Router,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private confirmationService: ConfirmationService,
    private unidadeService: UnidadeService,
    private enderecoService: EnderecoService
  ) {
    super(messageService);

    this.route.paramMap.subscribe(params => {
      if (params.has('idUnidade')) {
        this.idUnidade = params.get('idUnidade');
      }
    });

    this.form = this.fb.group({
      idUnidade: [this.idUnidade, Validators.required],
      cnpjSenat: [null, [Validators.required, CustomValidator.CNPJValidator]],
      endereco: this.fb.group({
        idEndereco: [null],
        cep: [null, [Validators.required]],
        logradouro: [null, Validators.required],
        complemento: [null, Validators.required],
        bairro: [null, Validators.required],
        cidade: [null, Validators.required],
        idUf: [null, Validators.required]
      }),
      gestorUnidade: this.fb.group({
        idGestorUnidade: [null],
        nome: [null, Validators.required],
        cpf: [null, [Validators.required, CustomValidator.CpfValidator]],
        rg: [null, Validators.required],
        idUfRg: [null, Validators.required],
        orgaoExpeditorRg: [null, Validators.required],
        email: [null, Validators.required]
      })
    });
  }

  ngOnInit() {
    this.getAllUnidades();
    this.getAllUfs();

    if (this.idUnidade !== undefined && this.idUnidade !== null) {
      this.carregarInformacoesUnidade(this.idUnidade);
    }
  }

  getAllUnidades() {
    this.unidadeService
      .getUnidades()
      .finally(() => (this.isLoading = false))
      .subscribe(
        unidades => {
          this.unidades = unidades;
        },
        error => this.gerenciaErro(error)
      );
  }

  getAllUfs() {
    this.unidadeService
      .getListaUf()
      .finally(() => (this.isLoading = false))
      .subscribe(
        ufs => {
          this.ufs = ufs;
        },
        error => this.gerenciaErro(error)
      );
  }

  getEnderecoByCep() {
    this.isCepDefinido = false;

    this.form.patchValue({
      endereco: {
        logradouro: null,
        complemento: null,
        bairro: null,
        idUf: null,
        cidade: null
      }
    });

    const cep = this.cep.value;
    if (Util.isNullOrEmptyOrUndefined(cep) || cep.length < 3) {
      return;
    }

    this.isLoading = true;
    this.enderecoService
      .getEnderecoByCep(Util.limpaCep(cep))
      .finally(() => (this.isLoading = false))
      .subscribe(
        endereco => {
          if (!Util.isNullOrEmptyOrUndefined(endereco)) {
            this.form.patchValue({
              endereco: {
                cidade: endereco.cidade,
                logradouro: endereco.logradouro,
                complemento: endereco.complemento,
                bairro: endereco.bairro,
                idUf: endereco.idUf
              }
            });
            this.isCepDefinido = true;
          } else {
            this.form.patchValue({
              endereco: {
                cidade: null,
                logradouro: null,
                complemento: null,
                bairro: null,
                idUf: null
              }
            });
            this.isCepDefinido = false;
          }
        },
        error => this.gerenciaErro(error)
      );
  }

  submit() {
      if (
      this.form.value.idUnidade === '' ||
      this.form.value.endereco.idUf === '' ||
      this.form.value.gestorUnidade.idUfRg === ''
    ) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Um campo obrigatório não foi preenchido!'
      });
    }

    if (this.form.valid) {
      this.confirmationService.confirm({
        message: 'Tem certeza que deseja salvar?',
        header: 'Confirmação',
        icon: 'fa fa-question-circle',
        accept: () => {
          this.form.value.cnpjSenat = Util.limpaCnpj(this.form.value.cnpjSenat);
          this.form.value.endereco.cep = Util.limpaCnpj(this.form.value.endereco.cep);
          this.form.value.gestorUnidade.cpf = Util.limpaCnpj(this.form.value.gestorUnidade.cpf);
          this.unidadeService.cadastrarInformacoesComplemetares(this.form.value)
            .finally(() => (this.isLoading = false))
            .subscribe(
              info => {
                this.router.navigate(['/unidade/informacoes-complementares']);
              },
              error => this.gerenciaErro(error)
            );
        }
      });
    } else {
      this.messageService.add({
        severity: 'warn',
        summary: 'Atenção',
        detail: 'Um campo obrigatório não foi preenchido!'
      });
    }
  }

  cancelar() {
    this.confirmationService.confirm({
      message: 'Deseja cancelar?',
      header: 'Confirmação',
      icon: 'fa fa-question-circle',
      accept: () => {
        this.router.navigate(['/unidade/informacoes-complementares']);
      }
    });
  }

  carregarInformacoesUnidade(idUnidade) {
    if (idUnidade != null || idUnidade !== '') {
      this.unidadeService
        .carregarInformacoesUnidade(idUnidade)
        .finally(() => (this.isLoading = false))
        .subscribe(
          unidade => {
            if (unidade != null) {
              this.form.patchValue({
                idUnidade: idUnidade,
                cnpjSenat: Util.formatAsCnpj(unidade.cnpjSenat),
                endereco: {
                  idEndereco: unidade.endereco.idEndereco,
                  cep: Util.formatAsCep(unidade.endereco.cep),
                  logradouro: unidade.endereco.logradouro,
                  complemento: unidade.endereco.complemento,
                  bairro: unidade.endereco.bairro,
                  cidade: unidade.endereco.cidade,
                  idUf: unidade.endereco.idUf
                },
                gestorUnidade: {
                  idGestorUnidade: unidade.gestorUnidade.idGestorUnidade,
                  nome: unidade.gestorUnidade.nome,
                  cpf: Util.formatAsCpf(unidade.gestorUnidade.cpf),
                  rg: unidade.gestorUnidade.rg,
                  idUfRg: unidade.gestorUnidade.idUfRg,
                  orgaoExpeditorRg: unidade.gestorUnidade.orgaoExpeditorRg,
                  email: unidade.gestorUnidade.email
                }
              });
              this.isCepDefinido = true;
            } else {
              this.form.patchValue({
                idUnidade: idUnidade,
                cnpjSenat: null,
                endereco: {
                  idEndereco: null,
                  cep: null,
                  logradouro: null,
                  complemento: null,
                  bairro: null,
                  cidade: null,
                  idUf: null
                },
                gestorUnidade: {
                  idGestorUnidade: null,
                  nome: null,
                  cpf: null,
                  rg: null,
                  idUf: null,
                  orgaoExpeditorRg: null
                }
              });
              this.isCepDefinido = false;
            }
          },
          error => this.gerenciaErro(error)
        );
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/unidade/cadastrar-informacoes-complementares/cadastrar-informacoes-complementares.component.ts